import { TimezoneInterceptor } from './timezone.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppURLInterceptor } from '@ppl/core';


// Http interceptor providers in outside-in order
export const HttpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AppURLInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TimezoneInterceptor, multi: true },
];
